import React, { Component } from 'react';
// import './Header.css';
import { RequireLogin } from './Login.js';
import TutorReady from './TutorReady'
import LessonList from './LessonList.js';

class Report extends Component {
	constructor(params) {
		super(params);

		this.page = 1;
		if(params.match.params && params.match.params.page)
			this.page = params.match.params.page;
	}
  render() {
    return (
      <div className="submit_report">
    	<RequireLogin />
        <TutorReady />
	      <h2>Submit a Lesson Report</h2>
      <p>
        <b>Student must log out before you - call asap if they haven't please<br></br>
        Use 01273 465122 for all lesson related issues, please do not text or call mobiles<br></br>
        If a student has been absent for 2 consecutive weeks, please email</b><br></br>
      </p>
      	<LessonList report="0" type="0" page={this.page} history={this.props.history}/>
      </div>
    );
  }
}

export default Report;
